import React, { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { BsEnvelope, BsFilePersonFill, BsTelephone } from "react-icons/bs";

import { fetchGET } from "../apiHelper";
import { kontaktiUM } from "../listOfApi";

const KontaktiUM = () => {

  const [claniceKontakti, setClaniceKontakti] = useState([]);

  useEffect(() => {
    fetchGET(kontaktiUM).then((data) => {
      if (data !== 0) {
        setClaniceKontakti(data);
      }
    });
    console.log(claniceKontakti, "aaa");
  }, []);

  return (
    <Container fluid className="mb-5">
      <Row>
        <Col className="main-header font-weight-bold">Kontakti UM</Col>
      </Row>
      <Row>
        <Col className="header-divider">
          <hr />
        </Col>
      </Row>
      <Row>
        {claniceKontakti?.map((clanica, clanicaIndex) => {
          return (
            <>
              <Row className="mt-4 mb-0">
                <Col><h3 className="m-0">{clanica.naziv}</h3></Col>
              </Row>
              <Row className="mb-2">
                <Col>{clanica.kontakt}</Col>
              </Row>
              <Row>
                {clanica.osebe.length > 0 ?
                  <Col style={{maxWidth: "440px"}}>
                    {clanica.osebe?.map((oseba, osebaIndex) => {
                      return (
                        <Card className="mb-3" style={{overflow: "hidden"}}>
                          <Card.Title className="p-3" style={{background: "#eee", fontSize: "15px", fontWeight: "600",margin: "0"}}>
                            <BsFilePersonFill />
                            &nbsp;&nbsp;{oseba.imePriimek}
                          </Card.Title>
                          <Card.Body>
                            <BsTelephone />&nbsp;&nbsp;
                            <span>{oseba.telefon}</span>
                            <br></br>
                            <BsEnvelope />&nbsp;&nbsp;
                            <a href={`mailto:`+oseba.mail}>{oseba.mail}</a>
                          </Card.Body>
                        </Card>
                      )}
                    )}
                  </Col> :
                  <Col>Ni podatkov!</Col>
                }
              </Row>
            </>
          );
        })}
      </Row>
    </Container>
  );
};

export default KontaktiUM;
